import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface EmploymentType {
  employmentType: string;
  count: number;
}

export interface EmployeeCountsData {
  totalEmployees: number;
  employmentTypes: EmploymentType[];
}

export type EmployeeCountsResponse = {
  success: boolean;
  message: string;
  data: EmployeeCountsData;
};

const fetchEmployeeCounts = async (
  organizationId: string
): Promise<EmployeeCountsResponse> => {
  const { data } = await customAxios.get<EmployeeCountsResponse>(
    `/users/organization/${organizationId}/employee-counts`
  );
  return data;
};

export const useGetEmployeeCounts = (organizationId?: string) =>
  useQuery<EmployeeCountsResponse, AxiosError>(
    ["employeeCounts", organizationId],
    () => fetchEmployeeCounts(organizationId as string),
    {
      enabled: Boolean(organizationId),
      onError: (error) => {
        showNotification({
          title: "Error Loading Employee Counts",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load employee counts",
          color: "red",
        });
      },
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
